"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSelectionBar = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var test_helpers_1 = require("../../lib/test-helpers");
var button_1 = require("../button");
var floating_bar_1 = require("../floating-bar");
var icons_1 = require("../icons");
var stack_1 = require("../stack");
var text_1 = require("../text");
function ObjectSelectionBar(props) {
    var actions = props.actions, clearItems = props.clearItems, _a = props.clearLabel, clearLabel = _a === void 0 ? 'Clear selection' : _a, items = props.items, propTestId = props.testId;
    return (react_1.default.createElement(floating_bar_1.FloatingBar, null,
        react_1.default.createElement(stack_1.Stack, { gap: 12, direction: "horizontal", alignItems: "center", testId: propTestId },
            react_1.default.createElement(text_1.Text, { color: "light", testId: (0, test_helpers_1.generateTestId)(propTestId, 'selection-count') },
                items.length,
                " selected"),
            actions.map(function (_a) {
                var label = _a.label, onClick = _a.onClick, variant = _a.variant, isDisabled = _a.isDisabled, testId = _a.testId;
                if (variant === 'text') {
                    return react_1.default.createElement(text_1.Text, null, label);
                }
                return (react_1.default.createElement(button_1.Button, { size: variant, type: "button", onClick: function () { return onClick(); }, key: "".concat(variant, "-").concat(label), disabled: isDisabled, testId: testId }, label));
            }),
            clearItems && (react_1.default.createElement(button_1.Button, { size: "transparent", onClick: clearItems, type: "button", style: { padding: 0, marginLeft: 8 }, testId: (0, test_helpers_1.generateTestId)(propTestId, 'clear-button') },
                react_1.default.createElement(stack_1.Stack, { gap: 8, direction: "horizontal", justifyContent: "center", alignItems: "center" },
                    react_1.default.createElement(icons_1.IconClose, null),
                    clearLabel))))));
}
exports.ObjectSelectionBar = ObjectSelectionBar;
//# sourceMappingURL=index.js.map